import ActiveUser from "./active-user";

export default class ActiveUserFactory {
  public create(userId: string): ActiveUser {
    return new ActiveUser(userId);
  }
}
